"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotVoiceMail = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotVoiceMail = _ref => {
  let {
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M6.394 25.594c.742 3.196 1.607 7.252 3.878 8.798 2.297 1.572 6.028.66 8.778-1.118 2.75-1.753 4.519-4.348 6.69-6.429 2.17-2.08 4.768-3.621 6.617-6.14 1.823-2.49 2.924-5.933 2.719-9.584-.205-3.651-1.717-7.51-4.7-8.207-2.982-.67-7.41 1.795-10.774 2.778-3.39.982-5.666.48-9.11.185C7.05 5.58 2.466 5.492 1.258 7.5c-1.21 1.983.932 6.064 2.351 9.273 1.395 3.235 2.016 5.598 2.786 8.82Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M9.168 26.667a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0 0h21.666m0 0a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotVoiceMail = SpotVoiceMail;
SpotVoiceMail.displayName = "SpotVoiceMail";